var React = require('react');

function Dharmachakra (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M31,19c0,6.626-5.374,12-12,12\n\tc-6.627,0-12-5.374-12-12c0-6.627,5.373-12,12-12C25.626,7,31,12.373,31,19z M19,17c-1.104,0-2,0.896-2,2s0.896,2,2,2s2-0.896,2-2\n\tS20.104,17,19,17z M19,17V2 M19,36V21 M21,19h15 M2,19h15 M20.414,17.586L31.021,6.979 M6.979,31.021l10.606-10.606 M20.414,20.414\n\tl10.606,10.606 M6.979,6.979l10.606,10.607"}));
}

Dharmachakra.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = Dharmachakra;

Dharmachakra.default = Dharmachakra;
